import React from "react";

interface Props {
  message: string;
}

const SuccessBox: React.FC<Props> = ({message}) => {
  return (
    <div className="box success">
      <p>{message}</p>
    </div>
  );
};

export default SuccessBox;
